module.exports = __webpack_public_path__ + "img/location.6b2b50f0.svg";